/**
 * Setup the environment for grid items
 */
import { Logger } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Setup the environment for grid items
 */
export default class GridItemEnvironment {
    /**
     * @param {AbstractItem} item
     * @param {Pimple} container
     */
    constructor(item, container) {
        this.item = item;

        this.container = container;
        this.layerManager = container.get('canvas.svg.layerManager');
        this.contextManager = container.get('canvas.contextManager');
        this.pathFactory = container.get('canvas.svg.pathFactory');
        this.itemFactory = container.get('canvas.itemFactory');
        this.productionDataStore = this.itemFactory.getProductionDataStore();
    }

    init() {
        Logger.debug('GridItemEnvironment.init():', this.item);

        this.context = new Ofcs.Editor.Context.Context(this.item, 'grid');

        this.itemLayer = this.layerManager.createItemLayer(this.item, {
            transform: this.pathFactory.getAbsoluteTransformString(this.item),
        });

        this.layerManager.createLayer('boxgrid', null, false, this.itemLayer);
        this.layerManager.createLayer('insert', { fill: '#CCC', opacity: 0.5 }, false, this.itemLayer);

        // Move item layer when the foam item is moved inside a box
        this.item.on('change', (grid) => {
            if (grid.hasChangedProperty('position')) {
                this.itemLayer.getElement().attr('transform', this.pathFactory.getAbsoluteTransformString(grid, true));
            }
        });

        this.gridManager = this.container.get('canvas.grid.gridManager');
    }

    activate() {
        Logger.debug('GridItemEnvironment.activate():', this.item);

        this.itemLayer.show();
        this.contextManager.addContext(this.context);
    }

    deactivate() {
        Logger.debug('GridItemEnvironment.deactivate():', this.item);

        this.itemLayer.hide();
        this.contextManager.removeContext(this.context);
    }
}
